"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Popover;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Overlay = require("../Overlay");
var _useDelayVisible2 = require("./useDelayVisible");
var _useParentScroll = require("../_utils/hooks/useParentScroll");
var _trigger2 = require("./trigger");
var _mergeStyle = require("../_utils/mergeStyle");
var _domref = require("../domref");
var _mergeRefs = require("../_utils/mergeRefs");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Popover(props) {
  var overlay = props.overlay,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? 'hover' : _props$trigger,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'top' : _props$placement,
    _props$placementOffse = props.placementOffset,
    placementOffset = _props$placementOffse === void 0 ? 10 : _props$placementOffse,
    escapeWithReference = props.escapeWithReference,
    children = props.children,
    closeOnScroll = props.closeOnScroll,
    overlayClassName = props.overlayClassName,
    _props$overlayStyle = props.overlayStyle,
    overlayStyle = _props$overlayStyle === void 0 ? {} : _props$overlayStyle,
    openDelay = props.openDelay,
    closeDelay = props.closeDelay,
    updateOnDimensionChange = props.updateOnDimensionChange,
    animationScaleFrom = props.animationScaleFrom,
    transitionTimeout = props.transitionTimeout;
  var _overlayRef = (0, _react.useRef)(null);
  var childrenRef = (0, _react.useRef)(null);
  var _useDelayVisible = (0, _useDelayVisible2.useDelayVisible)(props),
    visible = _useDelayVisible.visible,
    setVisible = _useDelayVisible.setVisible;
  var callFun = function callFun() {};
  if (visible && closeOnScroll) {
    callFun = function callFun() {
      return setVisible(false, closeDelay);
    };
  }

  // 设置了 closeOnScroll，则使用
  (0, _useParentScroll.useParentScroll)(childrenRef, callFun);
  var Triggers;
  var triggerExtraProps = {};

  // 使用指定的触发交互组件
  if (typeof trigger === 'string') {
    Triggers = _trigger2.buildinTriggers[trigger];
  }
  // 支持附加 props 的触发器
  else if (Array.isArray(trigger)) {
    var _trigger = (0, _slicedToArray2.default)(trigger, 2);
    Triggers = _trigger[0];
    triggerExtraProps = _trigger[1];
  }
  // 本身就是 Trigger 组件
  else {
    Triggers = trigger;
  }
  // fallback
  Triggers = Triggers || _trigger2.buildinTriggers.empty;
  var hasOneValidElement = _react.default.Children.count(children) === 1 && /*#__PURE__*/_react.default.isValidElement(_react.default.Children.toArray(children)[0]);
  return /*#__PURE__*/_react.default.createElement(Triggers, (0, _extends2.default)({}, triggerExtraProps, {
    overlayElementRef: _overlayRef,
    childrenElementRef: childrenRef,
    visible: visible,
    setVisible: setVisible,
    openDelay: openDelay,
    closeDelay: closeDelay,
    render: function render(_ref) {
      var overlayProps = _ref.overlayProps,
        childrenProps = _ref.childrenProps,
        referenceElement = _ref.referenceElement;
      return /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, {
        layers: [/*#__PURE__*/_react.default.createElement(_Overlay.Overlay.Layer, {
          key: "popover",
          visible: visible,
          placement: placement,
          placementOffset: placementOffset,
          animationScaleFrom: animationScaleFrom,
          referenceElement: props.referenceElement || referenceElement,
          content: overlay,
          overlayRef: function overlayRef(overlayElement) {
            _overlayRef.current = overlayElement;
          },
          overlayProps: _objectSpread(_objectSpread({}, overlayProps), {}, {
            className: (0, _classnames.default)(overlayProps.className, overlayClassName),
            style: (0, _mergeStyle.mergeStyle)({
              // 已经隐藏之后，动画过程不响应事件
              pointerEvents: visible ? undefined : 'none'
            }, overlayProps.style ? overlayProps.style : {}, overlayStyle)
          }),
          updateOnDimensionChange: updateOnDimensionChange,
          transitionTimeout: transitionTimeout,
          escapeWithReference: escapeWithReference
        })]
      }, function (ref) {
        return /*#__PURE__*/_react.default.createElement(_domref.DomRef, (0, _extends2.default)({}, childrenProps, {
          ref: (0, _mergeRefs.mergeRefs)(ref, childrenRef)
        }), hasOneValidElement ? _react.default.Children.toArray(children)[0] : /*#__PURE__*/_react.default.createElement("span", null, children));
      });
    }
  }));
}